import React from 'react';
import { FieldLabel } from '@/components/dynamic-field/field-label/FieldLabel';
import { Control, FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form/dist/types/form';
import { FieldProperties, FieldType, FieldValidation } from '@/services/formSchema.service';
import { FieldErrorComponent } from '@/components/dynamic-field/field-error/FieldErrorComponent';
import styles from './DynamicField.module.scss';
import { FieldInputWrapper } from '@/components/dynamic-field/field-input-wrapper/FieldInputWrapper';
import classNames from 'classnames';

export interface IDynamicField {
    register: UseFormRegister<any>;
    watch: UseFormWatch<any>;
    errors?: FieldErrors<any>;
    validation: FieldValidation;
    formValues: FieldValues;
    control: Control;
    fieldProperties: FieldProperties;
    setValue: UseFormSetValue<any>;
    initialValue: string | boolean;
    fieldType: string;
    fieldName: string;
}

export const DynamicField: React.FC<IDynamicField> = ({
    fieldType,
    errors,
    register,
    fieldName,
    validation,
    initialValue,
    fieldProperties,
    setValue,
    formValues,
    control,
    watch,
}) => {
    return (
        <div className={classNames(styles.field, { [styles.fieldHidden]: fieldType === FieldType.HIDDEN })}>
            <FieldLabel label={fieldProperties.label} fieldType={fieldType} />
            <FieldInputWrapper
                fieldType={fieldType}
                initialValue={initialValue}
                fieldProperties={fieldProperties}
                register={register}
                formValues={formValues}
                fieldName={fieldName}
                validation={validation}
                setValue={setValue}
                control={control}
                errors={errors}
                watch={watch}
            />
            {errors?.[fieldName] && <FieldErrorComponent errors={errors} fieldName={fieldName} />}
        </div>
    );
};
